/**
 * Decodes a GraphQL node ID into its __typename and numerical ID.
 * @param id - The GraphQL node ID to decode.
 * @returns An object with the __typename and numerical ID, or null if the ID is not provided.
 */
export const decodeGraphqlNodeId = (id?: string | null) => {
  if (!id) {
    return { __typename: null, numericalId: null }
  }
  const [__typename, numericalId] = atob(id).split(":")
  return { __typename, numericalId }
}
